module.exports = __webpack_public_path__ + "static/media/pettiemars.e88dde55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/pettiemars.jpg
// module id = 467
// module chunks = 0